import { useMemo } from 'react'
import getDaysInMonth from 'date-fns/getDaysInMonth'
import getYear from 'date-fns/getYear'

function useBirthdateOptions({ month = '0', year = '2000' }) {
  const monthOptions = [
    { label: 'January', value: 0 },
    { label: 'February', value: 1 },
    { label: 'March', value: 2 },
    { label: 'April', value: 3 },
    { label: 'May', value: 4 },
    { label: 'June', value: 5 },
    { label: 'July', value: 6 },
    { label: 'August', value: 7 },
    { label: 'September', value: 8 },
    { label: 'October', value: 9 },
    { label: 'November', value: 10 },
    { label: 'December', value: 11 },
  ]

  const dayOptions = useMemo(() => {
    const maxDay = getDaysInMonth(new Date(parseInt(year), parseInt(month)))
    const days = []
    for (let i = 1; i <= maxDay; i++) {
      days.push({ value: i.toString(), label: i.toString() })
    }
    return days
  }, [month, year])

  const yearOptions = useMemo(() => {
    const maxYear = getYear(new Date()) - 14
    const years = []

    for (let i = maxYear; i > maxYear - 86; i--) {
      years.push({ value: i.toString(), label: i.toString() })
    }
    return years
  }, [])

  return {
    yearOptions,
    dayOptions,
    monthOptions,
  }
}

export default useBirthdateOptions
